import Alpine from 'alpinejs'

Alpine.data('productMedia', () => ({
    selected: 'image',
    isSelectedMedia(type) {
        return this.selected === type
    },
    selectMedia(type) {
        if(this.selected === type) {
            return
        }
        this.selected = type
        this.$dispatch('product-media-selected', type)
    }
}))